import { q, client } from "../helpers/init-db";

/**
 *
 * @param {object} applicationData - object containing data of the application
 */
export function createApplication(applicationData) {
  
  return client
    .query(
      q.Create(q.Collection("applications"), {
        data: {
          ...applicationData,
        },
        permissions: {

        }
      })
    )
    .then(resp => resp)
    .catch(error => error);
}

/**
 *
 * @param applicationID - ID of the application
 */
export function getApplicationByID(applicationID) {
  return client
    .query(
      q.Get(q.Ref(q.Collection("applications"), applicationID))
    )
    .then(resp => resp)
    .catch(err => err);
}

/**
 *
 * @param {object} applicationRefID - faunaDb Applications collection reference ID
 * @param {string} newApplicationData - new data for application
 */

export function updateApplication(applicationRefID, newApplicationData) {
  return client
    .query(
      q.Update(q.Ref(q.Collection("applications"), applicationRefID), {
        data: newApplicationData
      })
    )
    .then(resp => resp)
    .catch(err => err);
}

  /**
 *
 * @param participantEmail - participant email
 * @param educationRef - education reference
 */
export function getApplicationByParticipant(participantEmail, educationRef) {
  return client
  .query(
    q.Paginate(q.Match(q.Index('application_by_participant'), participantEmail, educationRef))
  )
  .then(resp => resp)
  .catch(error => error);
}

  /**
 *
 * @param participantEmail - participant email
  * @param educationType - education type
  * @param attendancyStatus - code of participant's attendancy
 */
   export function getApplicationByParticipantForSpecificEducationType(participantEmail, educationType, attendancyStatus) {
    return client
    .query(
      q.Paginate(q.Match(q.Index('attended_to_specific_type_education'), participantEmail, educationType, attendancyStatus))
    )
    .then(resp => resp)
    .catch(error => error);
  }